$( document ).ready(function() {
  
    $( "#showForm" ).click(function() {
        $('#rc-form-pass').toggleClass('showPasswordForm')
    });

    $('.Shopi').click(function(){
        $('.mobile-mega-menu').addClass('showPasswordForm')

    });
    $('.closeMenu').click(function(){
        $('.mobile-mega-menu').removeClass('showPasswordForm')

    });
    $('.openMobileMenu').click(function(){
        $('.mobile-menu').addClass('showPasswordForm');
        $('.closeMenuMegaM').removeClass('hidden');
        // $('.closeMenuMegaM').addClass('showBMenu');
        $('.openMobileMenu').addClass('hidden')
        $('body').addClass("preventScrollingBody");
    });
    $('.closeMenuMegaM').click(function(){
        $('.mobile-menu').removeClass('showPasswordForm');
        // $('.closeMenuMegaM').removeClass('showBMenu');
        $('.closeMenuMegaM').addClass('hidden');
        // $('.openMobileMenu').removeClass('hideBMenu')
        $('.openMobileMenu').removeClass('hidden')
        $('body').removeClass("preventScrollingBody");

    });


// Variant Option 1
    var selectedElement = $('#select-one');
    var i 
    var newColor
    console.log(selectedElement)
    // Check default
    const flavourOne = $('#select-one').children('option:selected').data('id');
    const mainflavourOne = $('#select-one').children('option:selected').data('name');

    console.log(mainflavourOne)

    var swatch =  $('.color-swatch');
    changestr = flavourOne.toString();
    console.log(changestr);
    swatchNew = swatch+changestr
    console.log(swatchNew)
    var sN = swatchNew.split(']')
    console.log(sN)
    for(var i = 0; i < sN.length; i++){
        if(sN[1] == flavourOne){
            $("#swatch-"+sN[1]).removeClass('hidden')
            if(selectedElement.hasClass('productSelect')){
                $(selectedElement).addClass('remove-background')
                $(selectedElement).removeClass();
                $(selectedElement).addClass('remove-background');
                $(selectedElement).addClass('w-full');
                $(selectedElement).addClass('productSelect');
                $(selectedElement).addClass(mainflavourOne);
                // $('#select-one').addClass(flavourOne)
            }
         }
    }

    $('#select-one').change(function(){

        // console.log($(this).children('option:selected').data('name'));
        var colorClass = $(this).children('option:selected').data('name');
        // console.log('Class = ' + colorClass)
        var NewClass = colorClass.toString();
        NewClass.split('x')
        console.log(NewClass)
        flavour = $(this).children('option:selected').data('id');
        flavourString = flavour.toString();
        console.log(flavourString)
        for(var b = 0; b < swatch.length; b++){
           console.log(swatch[b]+flavourString)
           elementSwatch = swatch[b]+flavourString
           var swEl = elementSwatch.split(']');
           console.log(swEl)
            if(swEl[b] == flavourString){
                $(".allcolors").addClass('hidden');
                $("#swatch-"+swEl[b]).removeClass('hidden');
                $('#select-one').removeClass();
                $('#select-one').addClass('remove-background');
                $('#select-one').addClass('w-full');
                $('#select-one').addClass('productSelect');
                $('#select-one').addClass(NewClass);
            }
         
        
               
            
        }
        });


// Variant Option 2
    var selectedElementTwo = $('#select-two');
    var iTwo
    var newColor
    console.log(selectedElementTwo)
    // Check default
    const flavourTwo = $('#select-two').children('option:selected').data('id');
    const mainflavourTwo = $('#select-two').children('option:selected').data('name');
    console.log(mainflavourTwo)
    var swatchTwo =  $('.color-swatchz');
    changestrTwo = flavourTwo.toString();
    console.log(changestrTwo);
    swatchNewTwo = swatchTwo+changestrTwo
    console.log(swatchNewTwo)
    var sNTwo = swatchNewTwo.split(']')
    console.log(sNTwo)
    for(var iTwo = 0; iTwo < sNTwo.length; iTwo++){
        if(sNTwo[1] == flavourTwo){
            $("#swatch-two-"+sNTwo[1]).removeClass('hidden')
            if(selectedElementTwo.hasClass('productSelect')){
                $(selectedElementTwo).addClass('remove-background')
                $(selectedElementTwo).removeClass();
                $(selectedElementTwo).addClass('remove-background');
                $(selectedElementTwo).addClass('w-full');
                $(selectedElementTwo).addClass('productSelect');
                $(selectedElementTwo).addClass(mainflavourTwo);
                // $('#select-one').addClass(flavourOne)
            }
            }
    }
    // ON CHANGE OF THE Variant 2 DropDown
    $('#select-two').change(function(){
        // console.log($(this).children('option:selected').data('name'));
        var colorClassTwo = $(this).children('option:selected').data('name');
        // console.log('Class = ' + colorClass)
        var NewClassTwo = colorClassTwo.toString();
        NewClassTwo.split('x')
        console.log(NewClassTwo)
        flavourTwoS = $(this).children('option:selected').data('id');
        flavourStringTwo = flavourTwoS.toString();
        console.log(flavourStringTwo)
        for(var bTwo = 0; bTwo < swatchTwo.length; bTwo++){
           console.log(swatchTwo[bTwo]+flavourStringTwo)
           elementSwatchTwo = swatchTwo[bTwo]+flavourStringTwo
           var swElTwo = elementSwatchTwo.split(']');
           console.log(swElTwo)
            if(swElTwo[bTwo] == flavourStringTwo){
                $(".allcolorsz").addClass('hidden');
                $("#swatch-two-"+swElTwo[bTwo]).removeClass('hidden');
                $('#select-two').removeClass();
                $('#select-two').addClass('remove-background');
                $('#select-two').addClass('w-full');
                $('#select-two').addClass('productSelect');
                $('#select-two').addClass(NewClassTwo);
            }
         
            
        }
        });

     });